/* tslint:disable */

declare var Object: any;
export interface ProductCategoryTypeInterface {
  "id"?: number;
  "name": string;
  "code": string;
}

export class ProductCategoryType implements ProductCategoryTypeInterface {
  "id": number;
  "name": string;
  "code": string;
  constructor(data?: ProductCategoryTypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProductCategoryType`.
   */
  public static getModelName() {
    return "ProductCategoryType";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProductCategoryType for dynamic purposes.
  **/
  public static factory(data: ProductCategoryTypeInterface): ProductCategoryType{
    return new ProductCategoryType(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProductCategoryType',
      plural: 'ProductCategoryTypes',
      path: 'ProductCategoryTypes',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "code": {
          name: 'code',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ProductCategoryType.ts